import * as Yup from "yup";
import dayjs from "dayjs";
export const employeeValidationSchema = Yup.object().shape({
  // Official Information
  companyCode: Yup.number().required("companyCode is required"),
  employeeCode: Yup.number().min(0).required("employeeCode is required"),
  fullName: Yup.string().required("Employee Name is required"),
  uniqueId: Yup.string().required("Unique Id is required"),
  defaultShift: Yup.number()
    .typeError("Default Shift is required")
    .min(1, "Default Shift is required")
    .required("Default Value is required"),
  employeeType: Yup.string().required("Employee Type is required"),

  // 3 is used for Foreigner
  icno: Yup.string().when("employeeType", {
    is: (val) => val !== "3",
    then: (schema) => schema.required("Icno is required"),
    otherwise: (schema) => schema.notRequired(),
  }),
  finNumber: Yup.string().when("employeeType", {
    is: (val) => val === "3",
    then: (schema) => schema.required("Fin Number is required"),
    // .matches(/^[A-Z]\d{7}[A-Z]\d{7}$/, "Invalid Fin Number format"),
    otherwise: (schema) => schema.notRequired(),
  }),

  gender: Yup.string(), //.required("gender is required"),
  race: Yup.string(), //.required("race is required"),
  nationality: Yup.string().required("Nationality is required"),

  departmentCode: Yup.number()
    .transform((value, originalValue) => (originalValue === "" ? 0 : value))
    .default(0)
    .min(1, "Department is required")
    .required("Department is required"),

  // .min(1, "Department is required")
  // .typeError("Department is required")
  // .required("Department is required"),
  designationCode: Yup.number()
    .transform((value, originalValue) => (originalValue === "" ? 0 : value))
    .default(0)
    .min(1, "Designation is required")
    .required("Designation is required"),
  // .min(1, "Designation is required")
  // .typeError("Designation is required")
  // .required("Designation is required"),
  jobTitle: Yup.string(),
  confirmationDate: Yup.string().nullable(),
  joinDate: Yup.string().required("Join Date is required"),
  locationCode: Yup.string().required("Location is required"),
  groups: Yup.string().nullable(),
  employmentStatus: Yup.number()
    .min(0)
    .typeError("Employment Status is required")
    .required("Employment Status is required"),
  jobGrade: Yup.string().nullable(),
  isSupervisor: Yup.boolean().default(false),
  //   .typeError("Select the employee is supervisor or not")
  //   .required("Select the employee is supervisor or not"),
  skilledOrUnSkilled: Yup.string().nullable(),
  // .oneOf(["S", "U"])
  // .required("skilledOrUnSkilled is required"),
  workingHoursPerDay: Yup.number(),
  // .min(0)
  // .max(24)
  // .required("Working Hours PerDay is required"),
  noofworkingDaysPerWeek: Yup.number(),
  // .min(1)
  // .max(7)
  // .typeError("noofworkingDaysPerWeek is required")
  // .required("noofworkingDaysPerWeek is required"),
  restDay: Yup.string().nullable(),
  // .test("restDay", "Select rest day", (value, context) => {
  //   return (
  //     value?.split(",")?.length >= 7 - context.parent.noofworkingDaysPerWeek
  //   );
  // })
  // .required("Rest day is required"),
  lengthofNoticePeriod: Yup.string().nullable(), //.required("lengthofNoticePeriod is required"),
  //   .required(
  //     "lengthofNoticePeriod is required"
  //   ),
  probationPeriodEnd: Yup.string().nullable(),
  probationPeriodStart: Yup.string().nullable(),

  //  CPF Details
  residentialType: Yup.string().when("employeeType", {
    is: (val) => val !== "3",
    then: (schema) => schema.required("CPF contribution type is required"),
    otherwise: (schema) => schema.default("OS").notRequired(),
  }),

  // residentialType: Yup.string().when("employeeType", {
  //   is: (val) => val !== "3",
  //   then: (schema) => schema.required("CPF contribution type is required"),
  //   otherwise: (schema) => schema.notRequired().default("OS"),
  // }),
  contributionCode: Yup.number().when("employeeType", {
    is: (val) => val !== "3",
    then: (schema) =>
      schema
        .typeError("Contribution Code is required")
        .required("Contribution Code is required"),
    otherwise: (schema) =>
      schema
        .default(0)
        .transform((value, originalValue) => (originalValue === "" ? 0 : value))
        .notRequired(),
  }),

  prcpfType: Yup.string().when("employeeType", {
    is: (val) => val === "1", //|| val !== "2", // || val !== 3, // || (val !== "1" && val !== 1),
    then: (schema) => schema.required("PR CPF Type is required"),
    otherwise: (schema) => schema.notRequired(),
  }),

  contributesSDL: Yup.string().when("employeeType", {
    is: (val) => val !== "3",
    then: (schema) =>
      schema
        .typeError("Contribute SDL is required")
        .required("Contribute SDL is required"),
    otherwise: (schema) => schema.notRequired(),
  }),

  sdlBreakdown: Yup.string().nullable(), //.required("SDL Breakdown is required"),
  prDate: Yup.string().nullable(),
  ppeSize: Yup.string(), //.required("PPE size is required"),
  shoeSize: Yup.string(), //.required("Shoe size is required"),
  ppeRemarks: Yup.string(), //.required("PPE Remarks is required"),
  employeeLogin: Yup.array().of(
    Yup.object().shape({
      companyCode: Yup.number(),
      employeeID: Yup.number(),
      // userName: Yup.string()
      //   .email("User Name is must to be email")
      //   .required("User Name is required"),
      userName: Yup.string()
        .email("User Name must be an email")
        .test(
          "match-email",
          "User Name must be same as Email",
          function (value) {
            const rootValues = this.from?.[1]?.value;
            return value === rootValues?.email;
          },
        )
        .required("User Name is required"),

      password: Yup.string()
        .min(6, "Password must be at least 6 characters")
        .required("Password is required"),
      userType: Yup.string().required("User type is required"),
      loginType: Yup.array().required("Login Type is required"),
      defaultLoginLatitude: Yup.number(),
      defaultLoginLongitude: Yup.number(),
      lastLogin: Yup.string(),
      createUser: Yup.string(),
      createDate: Yup.string(),
      modifyUser: Yup.string(),
      modifyDate: Yup.string(),
      isActive: Yup.boolean().required("Login Active status is required"),
      isFirstLogin: Yup.boolean().nullable().default(true), // required("isFirstLogin is required"),
      // isLock: Yup.boolean().required("Login Lock status is required"),
    }),
  ),

  //   ID Details
  passCode: Yup.number()
    .min(1, "please select any one of above list")
    .typeError("please select any one of above list")
    .required("passCode is required"),

  // Salary Details
  salaryType: Yup.string().required("Salary Type is required"),
  daySalary: Yup.number()
    .transform((value, originalValue) =>
      originalValue === "" ||
      originalValue === null ||
      originalValue === undefined
        ? undefined
        : Number(value),
    )
    .nullable()
    .when("salaryType", {
      is: "Daily",
      then: (schema) =>
        schema
          .required("Day Salary is required for Daily salary type")
          // .integer("Day Salary must be an integer")
          .min(0.01, "Day Salary must be greater than 0"),
      otherwise: (schema) => schema.notRequired(),
    }),
  hourlySalary: Yup.number()
    .typeError("Hourly Salary must be a valid number")
    .transform((value, originalValue) =>
      originalValue === "" ||
      originalValue === null ||
      originalValue === undefined
        ? undefined
        : isNaN(originalValue)
          ? NaN
          : Number(originalValue),
    )
    .nullable()
    .when("salaryType", {
      is: "Hourly",
      then: (schema) =>
        schema
          .required("Hourly Salary is required for Hourly salary type")
          .min(0.01, "Hourly Salary must be greater than 0"),
      otherwise: (schema) => schema.notRequired(),
    }),

  basicSalary: Yup.number()
    .transform((value, originalValue) =>
      originalValue === "" ||
      originalValue === null ||
      originalValue === undefined
        ? undefined
        : Number(value),
    )
    .nullable()
    .when("salaryType", {
      is: "Monthly",
      then: (schema) =>
        schema
          .required("Monthly Salary is required for Monthly salary type")
          // .integer("Basic Salary must be an integer")
          .min(0.01, "Monthly Salary must be  greater than 0"),
      otherwise: (schema) => schema.notRequired(),
    }),
  paymentMode: Yup.number()
    .min(1, "Payment method is required")
    .typeError("Payment method is required")
    .required("Payment method is required"),
  bankName: Yup.string().required("Bank Name is required"),
  accountNo: Yup.string().nullable(),
  bankSwiftCode: Yup.string().nullable(),
  // .matches(/^\d+$/, "Account No should be numeric")
  // .required("Account No is required"),
  haveOverTimePay: Yup.boolean().required("Have OverTime Pay is required"),
  haveFullPay: Yup.boolean().required("Have full pay is required"),
  otDaySalary: Yup.number()
    .min(0, "otDaySalary is required")
    .required("otDaySalary is required"),
  otHourlySalary: Yup.number()
    .min(0, "Ot Hourly Salary is required")
    .required("Ot Hourly Salary is required"),

  oT1PayRate: Yup.number()
    .min(0, "OT1 Pay Rate is required")
    .required("OT1 Pay Rate is required"),

  oT2PayRate: Yup.number()
    .min(0, "OT2 Pay Rate is required")
    .required("OT2 Pay Rate is required"),

  oT3PayRate: Yup.number()
    .min(0, "OT3 Pay Rate is required")
    .required("OT3 Pay Rate is required"),

  // Personal Details Section
  dob: Yup.string().required("dob is required"),
  maritalStatus: Yup.string(),
  academicQualification: Yup.string().nullable(),
  //   .required(
  //     "academicQualification is required"
  //   ),
  address1: Yup.string().required("address1 is required"),
  address2: Yup.string().nullable(),
  address3: Yup.string().nullable(),
  country: Yup.string().required("country is required"),
  postalCode: Yup.string()
    .matches(/^\d{6}$/, "postalCode should be 6 digits")
    .required("postalCode is required"),
  bloodGroup: Yup.string().nullable(), //.required("bloodGroup is required"),
  // .oneOf(["A+", "A-", "B+", "B-", "O+", "O-", "AB+", "AB-"])
  // .required("bloodGroup is required"),
  personalEmail: Yup.string().nullable(), //.email().required("personalEmail is required"),
  email: Yup.string().nullable(), //required("email is required"),
  localContactNumber: Yup.string().nullable(), //.required("Local Contact Number is required"),
  // .typeError("Enter Local Contact Number")
  // .required("Enter Local Contact Number"),
  overseasContactNumber: Yup.string().nullable(), //.required("Overseas Contact Number is required"),
  // .typeError("Enter Overseas Contact Number")
  // .required("Enter Overseas Contact Number"),
  remarks: Yup.string().nullable(),
  passExpiryDate: Yup.string().nullable(),
  passIssueDate: Yup.string().nullable(),
  cpfEntitled: Yup.string().nullable(),
  identification: Yup.string().nullable(), //.required("Identification is required"),

  isActive: Yup.bool().required("isActive is required"),
  relationship: Yup.string().nullable(), //.required("Relationship is required"),
  emergencyContactPerson: Yup.string().nullable(), //.required("Emergency Contact Person is required"),
  // .required(
  //   "emergencyContact Person is required"
  // ),
  hpno: Yup.string()
    .matches(/^\d+$/, "Mobile No should be numeric")
    .required("Mobile No is required"),
  employeePhoto: Yup.string().nullable(),
  religion: Yup.string().nullable(), //.required("religion is required"),
  placeOfBirth: Yup.string().nullable(), //.required("placeOfBirth is required"),

  // .oneOf(["Single", "Married", "Divorced", "Widowed"])
  // .required("maritalStatus is required"),

  otPaidInDays: Yup.number().min(0).required("otPaidInDays is required"),
  officeNo: Yup.string().nullable(),
  //   Other Details
  mode: Yup.string().required("mode is required"),
  dateFormat: Yup.string().required("dateFormat is required"),
  createUser: Yup.string().required("createUser is required"),
  createDate: Yup.string().required("createDate is required"),
  modifyUser: Yup.string().required("modifyUser is required"),
  modifyDate: Yup.string().required("modifyDate is required"),

  resignedDate: Yup.string().nullable(),

  workDayPerWeek: Yup.number(),
  // .min(0)
  // .max(7)
  // .required("workDayPerWeek is required"),
  reportTo: Yup.string().nullable(),
  haveLoginPermission: Yup.boolean().required(
    "haveLoginPermission is required",
  ),
  dailyAllowance: Yup.number().min(0).required("dailyAllowance is required"),
  haveOverTimePayForExtraHours: Yup.boolean().required(
    "haveOverTimePayForExtraHours is required",
  ),
  haveNeedAttendance: Yup.boolean().required("haveNeedAttendance is required"),

  loginUserName: Yup.string().nullable(),
  aliasName: Yup.string().nullable(), // .required("aliasName is required"),
  preferedName: Yup.string().nullable(),
  surpervisorName: Yup.string().nullable(),
  payrollFrequency: Yup.string().nullable(),
  skillSet: Yup.string().nullable(),
  basicPayAmountType: Yup.string()
    // .oneOf(["SGD", "USD", "EUR"])
    .required("basicPayAmountType is required"),
  superAdmin: Yup.boolean().required("superAdmin is required"),
  workingTimingPerDay: Yup.string()
    // .min(0)
    // .max(24)
    .required("workingTimingPerDay is required"),
  userSecurity: Yup.string().nullable(),
  claimsTypes: Yup.string().nullable(),
  fundDonation: Yup.string().nullable(),
  clockInAndOutOnMobile: Yup.string().nullable(),
  // .required("Clock In And Out On Mobile is required"),

  passTypeDetails: Yup.array().of(
    Yup.object().shape({
      // passTypeID: Yup.number()
      //   .transform((value, originalValue) => (originalValue === "" ? 0 : value))
      //   .default(0),
      passCode: Yup.number()
        .transform((value, originalValue) => (originalValue === "" ? 0 : value))
        .default(0),
      nricNumber: Yup.string().nullable(),
      // .matches(/^[STFG]\d{7}[A-Z]$/, "Invalid NRIC format") // Singapore NRIC format
      // .required("NRIC Number is required"),
      photoIdBarcode: Yup.string().nullable(), //.required("Photo Id Barcode is required"),
      issuedDate: Yup.string().nullable(),
      // .typeError("Select the valid date")
      // .required("Issued date is required"),
      sector: Yup.string().nullable(), //.required("Sector is required"),
      levyAmount: Yup.number()
        .transform((value, originalValue) => (originalValue === "" ? 0 : value))
        .default(0)
        .required("Levy amount is required"),
      frontImage: Yup.string().nullable(),
      //   .required(
      //     "please select the document front image"
      //   ),
      backImage: Yup.string().nullable(),
      //   .required("please select the document back image"),
    }),
  ),
  inventoryDetails: Yup.array().of(
    Yup.object().shape({
      companyCode: Yup.number(),
      code: Yup.number(),
      employeeCode: Yup.number(),
      itemName: Yup.string().required("Please enter item name"),
      quantity: Yup.number()
        .min(1)
        .typeError("Please enter item quantity")
        .required("Please enter item quantity"),
      dateOfIssue: Yup.string().required("Please select issue date"),
      dateOfCollection: Yup.string().required("Please select collect date"),
      description: Yup.string(),
      createUser: Yup.string(),
      createDate: Yup.string(),
      modifyUser: Yup.string(),
      modifyDate: Yup.string(),
      isActive: Yup.boolean(),
    }),
  ),
  workExperienceDetails: Yup.array().of(
    Yup.object().shape({
      companyCode: Yup.number(),
      code: Yup.number(),
      employeeCode: Yup.number(),
      department: Yup.string().required("Please enter department"),
      designation: Yup.string().required("Please enter designation"),
      weFromdate: Yup.string().required("Please select start date"),
      weTodate: Yup.string().required("Please select end date"),
      salary: Yup.number().required("Please enter salary"),
      remarks: Yup.string(),
      createUser: Yup.string(),
      createDate: Yup.string(),
      modifyUser: Yup.string(),
      modifyDate: Yup.string(),
      isActive: Yup.boolean(),
    }),
  ),
  certificationsDetails: Yup.array().of(
    Yup.object().shape({
      courseName: Yup.string().required("course name is required"),
      abbreviation: Yup.string().required("abbreviation is required"),
      certificateNumber: Yup.string().required(
        "certificate number is required",
      ),
      issueDate: Yup.string().nullable().default(""), //.required("issue date is required"),
      expiryDate: Yup.string().nullable().default(""), //.required("expiry date is required"),
      documentImage: Yup.string().nullable().default(""),
      documentImageBack: Yup.string().nullable().default(""),
      remarks: Yup.string(),
    }),
  ),
  educationalQualificationList: Yup.array().of(
    Yup.object().shape({
      degreeName: Yup.string().required("degree name is required"),
      fieldOfStudy: Yup.string().required("field of study is required"),
      institutionName: Yup.string().required("institution name is required"),
      startDate: Yup.string().required("start date is required"),
      endDate: Yup.string().required("end date is required"),
      grade: Yup.string().required("grade is required"),
      country: Yup.string().required("country is required"),
      documentImage: Yup.string().nullable(),
      remarks: Yup.string(),
    }),
  ),
  otherVisaDetails: Yup.array().of(
    Yup.object().shape({
      visaNumber: Yup.string().required("Visa Number is required"),
      typeofVisa: Yup.string().required("Type of Visa is required"),
      duration: Yup.string().required("Duration is required"),
      issuesDate: Yup.string().required("Issues Date is required"),
      expiryDate: Yup.string().required("Expiry Date is required"),
      issuedBy: Yup.string().required("Issued By is required"),
      sposorship: Yup.string().required("Sposorship is required"),
      busniessVisa: Yup.string().required("Business Visa is required"),
      country: Yup.string().required("Country is required"),
      agentName: Yup.string().required("Agent Name is required"),
      agentPhone: Yup.number().required("Agent Phone is required"),
      agentEmail: Yup.string().required("Agent Email is required"),
      frontImage: Yup.string(), //.required("Visa Number is required"),
      backImage: Yup.string(), //.required("Visa Number is required"),
      isActive: Yup.bool().required("Statis is required"),
    }),
  ),

  contractDetails: Yup.array().of(
    Yup.object().shape({
      code: Yup.number(),
      companyCode: Yup.number(),
      employeeCode: Yup.number(),
      contractType: Yup.string().required("Contract Type is required"),
      duration: Yup.string().required("Duration is required"),
      contractStartDate: Yup.string().required(
        "Contract Start Date is required",
      ),
      contractExpiryDate: Yup.string().required(
        "Contract Expiry Date is required",
      ),
      issuedBy: Yup.string().required("Issued By is required"),
      status: Yup.string().required("Contract Status is required"),
      frontImage: Yup.string(),
      backImage: Yup.string(),
      isActive: Yup.bool().required("Statis is required"),
      createUser: Yup.string(),
      createDate: Yup.string(),
      modifyUser: Yup.string(),
      modifyDate: Yup.string(),
    }),
  ),
  employmentType: Yup.string(), //.required("Employment Type is required"),
  nsEligible: Yup.boolean(), //.required("NS Eligible is required"),
  contractType: Yup.string(), //.required("Contract Type is required"),
  contractExpiryDate: Yup.string().nullable(),
  mondayWorkingMode: Yup.string().required("Monday Working Mode is required"),
  tuesdayWorkingMode: Yup.string().required("Tuesday Working Mode is required"),
  wednesdayWorkingMode: Yup.string().required(
    "Wednesday Working Mode is required",
  ),
  thursdayWorkingMode: Yup.string().required(
    "Thursday Working Mode is required",
  ),
  fridayWorkingMode: Yup.string().required("Friday Working Mode is required"),
  saturdayWorkingMode: Yup.string().required(
    "Saturday Working Mode is required",
  ),
  sundayWorkingMode: Yup.string().required("Sunday Working Mode is required"),

  projectCode: Yup.array(),
  extraHoursRate: Yup.number().min(0).required("Extra Hours Rate Required"),
  netcoTrade: Yup.string(),
  momTrade: Yup.string(),
  excludeTime: Yup.string(),

  cpfAccountDetails: Yup.array().when("employeeType", {
    is: (val) => val !== "3",
    then: (schema) =>
      schema.of(
        Yup.object().shape({
          // nric: Yup.string().required("NRIC is required"),
          employeeCPFAccountNumber: Yup.string()
            .typeError("Employee CPF Account Number")
            .required("Employee CPF Account Number is required"),
          additionalCPFAccount: Yup.string()
            .typeError("Additional CPF Account")
            .required("Additional CPF Account is required"),
          employerCPFAccount: Yup.string()
            .typeError("Employer CPF Account")
            .required("Employer CPF Account is required"),
          cpfStatus: Yup.bool().required("CPF Status is required"),
          autoDetectCPF: Yup.bool().required("Auto Detect CPF is required"),
          includeIR8ASubmission: Yup.bool().required(
            "Include IR8A Submission is required",
          ),
          sdfRequired: Yup.bool().required("SDF Required is required"),
          voluntaryCPFContribution: Yup.number()
            .typeError("Voluntary CPF Contribution")
            .required("Voluntary CPF Contribution is required"),
          // employeeAmount: Yup.number()
          //   .typeError("Employee Amount")
          //   .required("Employee Amount is required"),
          // employerAmount: Yup.number()
          //   .typeError("Employer Amount")
          //   .required("Employer Amount is required"),
          isActive: Yup.bool().required("Statis is required"),
        }),
      ),
    otherwise: (schema) => schema.notRequired(),
  }),

  accommodationDetail: Yup.array().of(
    Yup.object().shape({
      companyCode: Yup.number(),
      accommodationCode: Yup.number(),
      employeeCode: Yup.number(),
      accommodationName: Yup.string().required(
        "Accommodation Name is required",
      ),
      dormitoryCode: Yup.number(),
      room: Yup.string().required("Room is required"),
      bed: Yup.string().required("Bed is required"),
      startDate: Yup.string().required("Start Date is required"),
      endDate: Yup.string().required("End Date is required"),
      isActive: Yup.bool(),
      createUser: Yup.string(),
      createDate: Yup.string(),
      modifyUser: Yup.string(),
      modifyDate: Yup.string(),
    }),
  ),

  employeeKidsDetail: Yup.array().of(
    Yup.object().shape({
      companyCode: Yup.number(),
      code: Yup.number(),
      employeeCode: Yup.number(),
      kidName: Yup.string().required("Kid Name is required"),
      dateOfBirth: Yup.string().required("Date of Birth is required"),
      gender: Yup.string().required("Gender is required"),
      schoolName: Yup.string().required("School Name is required"),
      grade: Yup.string().required("Grade is required"),
      isActive: Yup.bool(),
      createUser: Yup.string(),
      createDate: Yup.string(),
      modifyUser: Yup.string(),
      modifyDate: Yup.string(),
    }),
  ),

  dependantDetail: Yup.array().of(
    Yup.object().shape({
      companyCode: Yup.number(),
      code: Yup.number(),
      employeeCode: Yup.number(),
      dependantName: Yup.string().required("Dependant Name is required"),
      icNumber: Yup.string().required("IC Number is required"),
      appliedOn: Yup.string().required("Applied On is required"),
      issuedOn: Yup.string().required("Issued On is required"),
      expiryDate: Yup.string().required("Expiry Date is required"),
      remarks: Yup.string(),
      fin: Yup.string().required("FIN is required"),
      relationship: Yup.string().required("Relationship is required"),
      working: Yup.string().required("Working is required"),
      companySponsored: Yup.bool(),
      frontImage: Yup.string().nullable(),
      backImage: Yup.string().nullable(),
      isActive: Yup.bool(),
      createUser: Yup.string(),
      createDate: Yup.string(),
      modifyUser: Yup.string(),
      modifyDate: Yup.string(),
    }),
  ),

  allowanceDetails: Yup.array().of(
    Yup.object().shape({
      companyCode: Yup.number().required("companyCode is required"),
      code: Yup.number()
        .min(1, "Select Allowance")
        .required("code is required"),
      description: Yup.string().required("description is required"),
      isActive: Yup.boolean().required("isActive is required"),
      amount: Yup.number()
        .typeError("amount is required")
        .required("amount is required"),
    }),
  ),

  deductionDetails: Yup.array().of(
    Yup.object().shape({
      companyCode: Yup.number().required("companyCode is required"),
      code: Yup.number()
        .min(1, "Select Deduction")
        .required("code is required"),
      description: Yup.string().required("description is required"),
      isActive: Yup.boolean().required("isActive is required"),
      amount: Yup.number()
        .typeError("amount is required")
        .required("amount is required"),
    }),
  ),
});

export const workingHoursValidationSchema = Yup.object().shape({});
